import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, { ReactNode, ReactNodeArray } from 'react';
import WrapperEsimVideo from './WrapperEsimVideo.js';
import WrapperEsimVideoData from '../../../Models/Content/AccordionCarouselBannerBlockData';

export default class WrapperEsimVideoBlock extends EpiComponent<WrapperEsimVideoData> {

  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ['wrapper-esim-video-block'];
    if (this.props.data.padding?.value) cssClasses.push(this.props.data.padding?.value);
    if (this.props.data.margin?.value) cssClasses.push(this.props.data.margin?.value); 

    return (
      <div className={cssClasses.join(" ")}>
        <WrapperEsimVideo 
          context={this.getContext()}
          iContent={this.props.data}
        />
      </div>
    );
  };
};

